<template>
  <div class="down_menu">
    <div class="down_menu_title">
      <div class="title_text" :style="'background-image: url(' + filePath + '/nemojoyWebSiteFile/imgs/indexHead/indexHeadDownMenuBac.png); background-repeat: no-repeat; background-size: 100% 100%;'">
        <div :style="have_active ? 'color: rgb(224, 15, 0)' : ''">{{ item.n }}</div>
        <div class="triangle_down" />
      </div>
    </div>
    <div class="menu">
      <template v-for="(it, index) in item.child">
        <a v-if="it.url && it.url.indexOf('http:') >= 0" :key="index" :href="it.url">
          <div :class="router_url === it.url ? 'item_active' : ''" class="item" :style="'background-image: url(' + filePath +'/nemojoyWebSiteFile/imgs/indexHead/indexHeadDownMenuBac.png); background-repeat: no-repeat; background-size: 100% 100%;'">{{ it.name }}</div>
        </a>
        <router-link v-else :key="index" :to="it.url">
          <div :class="router_url === it.url ? 'item_active' : ''" class="item" :style="'background-image: url(' + filePath +'/nemojoyWebSiteFile/imgs/indexHead/indexHeadDownMenuBac.png); background-repeat: no-repeat; background-size: 100% 100%;'">{{ it.name }}</div>
        </router-link>
      </template>
    </div>
  </div>
</template>

<script>
import vv from '@/components/varVariable'

export default {
  name: 'DownMenu',
  props: {
    'item': {
      type: Object,
      default: null
    }
  },
  data: function() {
    return {
      router_url: this.$route.path,
      have_active: false
    }
  },
  computed: {
    filePath() {
      return vv.fileHttp
    }
  },
  created() {
    if (!this.item) {
      return
    }

    for (let i = 0; i < this.item.child.length; i++) {
      const it = this.item.child[i]
      if (this.router_url === it.url) {
        this.have_active = true
        return
      }
    }
    this.have_active = false
  }
}
</script>

<style lang="scss" scoped>
.down_menu {
  width: 100%;
  height: 100%;
  color: rgb(141, 140, 140);

  .down_menu_title {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    .title_text {
      padding: 5px 20px;
      color: rgb(255, 255, 255);;
      display: flex;
      align-items: center;

      .triangle_down {
        width: 0;
        height: 0;
        border-top: 9px solid white;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        margin-left: 10px;
        transition: all .2s;
      }
    }
  }

  .menu {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    left: 5px;
    top: -22px;
    z-index: 999;
    max-height: 0;
    overflow: hidden;
    border-radius: 0 0 5px 5px;
    -webkit-transform: perspective(400) rotate3d(1, 0, 0, -90deg);
    -webkit-transform-origin: 50% 0;
    -webkit-transition: 350ms;
    -moz-transition: 350ms;
    -o-transition: 350ms;
    transition: 350ms;

    .item {
      text-align: center;
      padding: 10px 54px 10px 25px;
    }

    .item:hover {
      color: rgb(224, 15, 0);
      background-color: rgba(53, 45, 42, .8);
    }

    .item_active{
      color: rgb(224, 15, 0);
    }
  }
}

.down_menu:hover {
  .down_menu_title {
    .title_text {
      .triangle_down {
        transform: rotate(180deg);
        transition: all .2s;
      }
    }
  }

  .menu {
    max-height: 1000px;
    -webkit-transform: perspective(400) rotate3d(0, 0, 0, 0);
  }
}
</style>
